import { render, staticRenderFns } from "./AssignmentRoomFilter.vue?vue&type=template&id=ebb60fba&"
import script from "./AssignmentRoomFilter.vue?vue&type=script&lang=js&"
export * from "./AssignmentRoomFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports